import clsx from 'clsx';
import type * as React from 'react';

import { Icon } from '@gitbook/spine-icons';

import { Tooltip, type TooltipProps } from './Tooltip';

/**
 * A tooltip indicator that shows a tooltip when hovered.
 */
export function TooltipIndicator(
    props: Pick<TooltipProps, 'label'> & {
        className?: string;
        style?: React.CSSProperties;
    }
) {
    if (!props.label) {
        return null;
    }
    return (
        <Tooltip label={props.label} delay={200}>
            <div
                className={clsx(
                    'relative inline-flex shrink-0 text-muted hover:text-base',
                    props.className
                )}
                style={props.style}
            >
                <Icon.InfoCircle className="size-full" />
            </div>
        </Tooltip>
    );
}
